module.exports = __webpack_public_path__ + "img/camel-comb2-2.55168a79.jpg";